import * as angular from "angular";
import {ViewFilterSettingsService} from "../commons/services/view-filter-settings.service";
import {CommonsService} from "../commons/services/commons-service.service";
import {GroupModel} from "../groups/models/group.model";
import * as _ from "lodash";
import {DateRangeTimeFiltersService} from "../commons/services/date-range-time-filters.service";

angular
  .module('bringoz.admin.reports')
  .config(DeliveriesConfig);

/* @ngInject */
function DeliveriesConfig($stateProvider, $sceDelegateProvider, apiConfig) {

  $sceDelegateProvider.resourceUrlWhitelist([
    // Allow same origin resource loads.
    'self',
    // Allow loading from our assets domain. **.
    `${apiConfig.sisence?.url}/**`
    // 'https://bringoz.sisense.com/**',
    // 'https://bringoz-dev.sisense.com/**'
  ]);

  $stateProvider

    .state('reports', {
      parent: 'bringoz.site',
      url: '/reports?from&:to',
      abstract: true,
      controllerAs: 'vm',
      template: '<reports-view site="vm.site"></reports-view>',
      controller: function (site, $stateParams) {
        this.site = site;
        if ($stateParams.from && $stateParams.to) {
          this.from = parseInt($stateParams.from);
          this.to = parseInt($stateParams.to);
        }
      },
      resolve: {
        google: ['googleChartApiPromise', function (googleChartApiPromise) {
          return googleChartApiPromise;
        }]
      }
    })

    // Sisense
    .state('sisense', {
      parent: 'bringoz.site',
      url: '/sisense',
      controllerAs: 'vm',
      template: '<reports-sisense-view configuration="vm.configuration"></reports-sisense-view>',
      controller: function (triBreadcrumbsService, configuration, site) {

        this.configuration = configuration;

        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Sisense Reports"});
        triBreadcrumbsService.addCrumb({name: "Reporting & Analytics"});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      },
      resolve: {
        configuration: function (site, reportsRequests) {
          return reportsRequests.getSisenseSsoData();
        }
      }
    })

    // Sisense Timeline
    .state('sisense-timeline', {
      parent: 'bringoz.site',
      url: '/sisense-timeline?:branchIds&:agentIds&:groupIds&:date&:page&:size',
      controllerAs: 'vm',
      template: '<reports-sisense-timeline-view configuration="vm.configuration" selected-quick-filter-id="vm.selectedQuickFilterId" branch-ids="vm.branchIds"' +
        ' agent-ids="vm.agentIds" group-ids="vm.groupIds" groups-branch-ids="vm.groupsBranchIds" date="vm.date" page="vm.page" size="vm.size"></reports-sisense-timeline-view>',
      controller: function ($state, $stateParams, triBreadcrumbsService, viewFilterSettingsService: ViewFilterSettingsService,
                            configuration, commonsService: CommonsService, groups, site) {

        this.configuration = configuration;
        const quickActiveFilter = viewFilterSettingsService.getActiveQuickFilter($state.current.name);
        this.selectedQuickFilterId = quickActiveFilter?.id;

        this.groupIds = commonsService.parseArrayStateParam($stateParams.groupIds) || quickActiveFilter?.settings.groupIds;
        this.groupsBranchIds = [];

        if (groups.length) {
          groups.forEach((g: GroupModel) => {
            if (g.branchIds?.length) {
              this.groupsBranchIds = this.groupsBranchIds.concat(g.branchIds);
            }
          });
        }

        this.branchIds = _.uniq(this.groupsBranchIds.concat(commonsService.parseArrayStateParam($stateParams.branchIds) || quickActiveFilter?.settings.branchIds || viewFilterSettingsService.getBranchIds() || []));
        this.agentIds = commonsService.parseArrayStateParam($stateParams.agentIds) || quickActiveFilter?.settings.agentIds || [];

        this.date = $stateParams.date ? parseInt($stateParams.date) : undefined;
        this.page = $stateParams.page ? parseInt($stateParams.page) : undefined;
        this.size = $stateParams.size ? parseInt($stateParams.size) : undefined;

        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Frontline Timeline"});
        triBreadcrumbsService.addCrumb({name: "Reporting & Analytics"});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      },
      resolve: {
        configuration: function (site, reportsRequests) {
          return reportsRequests.getSisenseSsoData();
        },
        groups: function ($groups, $stateParams, site) {
          return $stateParams.groupIds?.length ? $groups().$asyncValues($stateParams.groupIds) : [];
        }
      }
    })

    // Deliveries
    .state('reports.deliveries', {
      url: '/deliveries',
      abstract: true,
      template: '<ui-view></ui-view>'
    })

    // Deliveries - Site Deliveries
    .state('reports.deliveries.site-deliveries', {
      url: '/site-deliveries',
      reloadOnSearch: false,
      template: '<reports-site-deliveries from="from" to="to"></reports-site-deliveries>',
      controller: function ($scope, $stateParams, triBreadcrumbsService) {

        if ($stateParams.from || $stateParams.to) {
          $scope.from = parseInt($stateParams.from);
          $scope.to = parseInt($stateParams.to);
        }

        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Site Deliveries"});
        triBreadcrumbsService.addCrumb({name: "Deliveries"});
        triBreadcrumbsService.addCrumb({name: "Reports"});
        triBreadcrumbsService.addCrumb({name: "Reporting & Analytics"});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      }
    })

    // Deliveries - Site Created Deliveries
    .state('reports.deliveries.site-created-deliveries', {
      url: '/site-created-deliveries',
      reloadOnSearch: false,
      template: '<reports-site-created-deliveries from="from" to="to"></reports-site-created-deliveries>',
      controller: function ($scope, $stateParams, triBreadcrumbsService) {

        if ($stateParams.from || $stateParams.to) {
          $scope.from = parseInt($stateParams.from);
          $scope.to = parseInt($stateParams.to);
        }

        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Site Created Deliveries"});
        triBreadcrumbsService.addCrumb({name: "Deliveries"});
        triBreadcrumbsService.addCrumb({name: "Reports"});
        triBreadcrumbsService.addCrumb({name: "Reporting & Analytics"});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      }
    })

    // Deliveries - Late Deliveries
    .state('reports.deliveries.late', {
      url: '/late-deliveries',
      reloadOnSearch: false,
      template: '<reports-late-deliveries from="from" to="to"></reports-late-deliveries>',
      controller: function ($scope, $stateParams, triBreadcrumbsService) {

        if ($stateParams.from || $stateParams.to) {
          $scope.from = parseInt($stateParams.from);
          $scope.to = parseInt($stateParams.to);
        }

        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Delays Report"});
        triBreadcrumbsService.addCrumb({name: "Deliveries"});
        triBreadcrumbsService.addCrumb({name: "Reports"});
        triBreadcrumbsService.addCrumb({name: "Reporting & Analytics"});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      }
    })



    // Performance
    .state('reports.performance', {
      url: '/performance',
      abstract: true,
      template: '<ui-view></ui-view>'
    })

    // Performance - Completed Deliveries - Shippers
    .state('reports.performance.deliveries-completion-shippers', {
      url: '/deliveries-completion/shippers',
      reloadOnSearch: false,
      template: '<reports-deliveries-completion-shipper from="from" to="to"></reports-deliveries-completion-shipper>',
      controller: function ($scope, $stateParams, triBreadcrumbsService) {

        if ($stateParams.from || $stateParams.to) {
          $scope.from = parseInt($stateParams.from);
          $scope.to = parseInt($stateParams.to);
        }

        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Shipper Accounts"});
        triBreadcrumbsService.addCrumb({name: "Completed Deliveries"});
        triBreadcrumbsService.addCrumb({name: "Performance"});
        triBreadcrumbsService.addCrumb({name: "Reports"});
        triBreadcrumbsService.addCrumb({name: "Reporting & Analytics"});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      }
    })

    // Performance - Completed Deliveries - Vendors
    .state('reports.performance.deliveries-completion-vendors', {
      url: '/deliveries-completion/vendors',
      reloadOnSearch: false,
      template: '<reports-deliveries-completion-vendors from="from" to="to"></reports-deliveries-completion-vendors>',
      controller: function ($scope, $stateParams, triBreadcrumbsService) {

        if ($stateParams.from || $stateParams.to) {
          $scope.from = parseInt($stateParams.from);
          $scope.to = parseInt($stateParams.to);
        }

        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Carrier Accounts"});
        triBreadcrumbsService.addCrumb({name: "Completed Deliveries"});
        triBreadcrumbsService.addCrumb({name: "Performance"});
        triBreadcrumbsService.addCrumb({name: "Reports"});
        triBreadcrumbsService.addCrumb({name: "Reporting & Analytics"});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      }
    })

    // Performance - Completed Deliveries - Drivers
    .state('reports.performance.deliveries-completion-drivers', {
      url: '/deliveries-completion/drivers',
      reloadOnSearch: false,
      template: '<reports-deliveries-completion-drivers from="from" to="to"></reports-deliveries-completion-drivers>',
      controller: function ($scope, $stateParams, triBreadcrumbsService) {

        if ($stateParams.from || $stateParams.to) {
          $scope.from = parseInt($stateParams.from);
          $scope.to = parseInt($stateParams.to);
        }

        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Drivers"});
        triBreadcrumbsService.addCrumb({name: "Completed Deliveries"});
        triBreadcrumbsService.addCrumb({name: "Performance"});
        triBreadcrumbsService.addCrumb({name: "Reports"});
        triBreadcrumbsService.addCrumb({name: "Reporting & Analytics"});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      }
    })


    // Performance - Tasks Accuracy - Shippers
    .state('reports.performance.tasks-accuracy-shippers', {
      url: '/tasks-accuracy/shippers',
      reloadOnSearch: false,
      template: '<reports-tasks-accuracy-shipper from="from" to="to"></reports-tasks-accuracy-shipper>',
      controller: function ($scope, $stateParams, triBreadcrumbsService) {

        if ($stateParams.from || $stateParams.to) {
          $scope.from = parseInt($stateParams.from);
          $scope.to = parseInt($stateParams.to);
        }

        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Shipper Accounts"});
        triBreadcrumbsService.addCrumb({name: "Tasks Accuracy"});
        triBreadcrumbsService.addCrumb({name: "Performance"});
        triBreadcrumbsService.addCrumb({name: "Reports"});
        triBreadcrumbsService.addCrumb({name: "Reporting & Analytics"});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      }
    })

    // Performance - Tasks Accuracy - Vendors
    .state('reports.performance.tasks-accuracy-vendors', {
      url: '/tasks-accuracy/vendors',
      reloadOnSearch: false,
      template: '<reports-tasks-accuracy-vendors from="from" to="to"></reports-tasks-accuracy-vendors>',
      controller: function ($scope, $stateParams, triBreadcrumbsService) {

        if ($stateParams.from || $stateParams.to) {
          $scope.from = parseInt($stateParams.from);
          $scope.to = parseInt($stateParams.to);
        }

        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Carrier Accounts"});
        triBreadcrumbsService.addCrumb({name: "Tasks Accuracy"});
        triBreadcrumbsService.addCrumb({name: "Performance"});
        triBreadcrumbsService.addCrumb({name: "Reports"});
        triBreadcrumbsService.addCrumb({name: "Reporting & Analytics"});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      }
    })

    // Performance - Tasks Accuracy - Drivers
    .state('reports.performance.tasks-accuracy-drivers', {
      url: '/tasks-accuracy/drivers',
      reloadOnSearch: false,
      template: '<reports-tasks-accuracy-drivers from="from" to="to"></reports-tasks-accuracy-drivers>',
      controller: function ($scope, $stateParams, triBreadcrumbsService) {

        if ($stateParams.from || $stateParams.to) {
          $scope.from = parseInt($stateParams.from);
          $scope.to = parseInt($stateParams.to);
        }

        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Drivers"});
        triBreadcrumbsService.addCrumb({name: "Tasks Accuracy"});
        triBreadcrumbsService.addCrumb({name: "Performance"});
        triBreadcrumbsService.addCrumb({name: "Reports"});
        triBreadcrumbsService.addCrumb({name: "Reporting & Analytics"});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      }
    })


    // Performance - Rush Hours - Shippers
    .state('reports.performance.rush-hours-shippers', {
      url: '/rush-hours/shippers',
      reloadOnSearch: false,
      template: '<reports-rush-hours-shipper from="from" to="to"></reports-rush-hours-shipper>',
      controller: function ($scope, $stateParams, triBreadcrumbsService) {

        if ($stateParams.from || $stateParams.to) {
          $scope.from = parseInt($stateParams.from);
          $scope.to = parseInt($stateParams.to);
        }

        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Shipper Accounts"});
        triBreadcrumbsService.addCrumb({name: "Rush Hours"});
        triBreadcrumbsService.addCrumb({name: "Performance"});
        triBreadcrumbsService.addCrumb({name: "Reports"});
        triBreadcrumbsService.addCrumb({name: "Reporting & Analytics"});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      }
    })

    // Deliveries - Service Areas
    .state('reports.deliveries.service-areas', {
      url: '/service-areas',
      reloadOnSearch: false,
      template: '<reports-service-areas from="from" to="to"></reports-service-areas>',
      controller: function ($scope, $stateParams, triBreadcrumbsService) {

        if ($stateParams.from || $stateParams.to) {
          $scope.from = parseInt($stateParams.from);
          $scope.to = parseInt($stateParams.to);
        }

        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Service Areas Report"});
        triBreadcrumbsService.addCrumb({name: "Deliveries"});
        triBreadcrumbsService.addCrumb({name: "Reports"});
        triBreadcrumbsService.addCrumb({name: "Reporting & Analytics"});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      }
    })


    // Performance - Routes Accuracy - Drivers
    .state('reports.performance.routes-accuracy-drivers', {
      url: '/routes-accuracy/drivers?:agentIds&:branchIds&:agentType&:accountIds&:tags',
      reloadOnSearch: false,
      controllerAs: 'vm',
      template: '<reports-routes-accuracy-drivers from="vm.from" to="vm.to" agent-type="vm.agentType" selected-quick-filter-id="vm.selectedQuickFilterId"' +
        ' branch-ids="vm.branchIds" agent-ids="vm.agentIds" account-ids="vm.accountIds" tags="vm.tags"></reports-routes-accuracy-drivers>',
      controller: function ($stateParams, commonsService: CommonsService, viewFilterSettingsService: ViewFilterSettingsService, $state, triBreadcrumbsService) {

        const quickActiveFilter = viewFilterSettingsService.getActiveQuickFilter($state.current.name);

        if ($stateParams.from || $stateParams.to) {
          this.from = parseInt($stateParams.from);
          this.to = parseInt($stateParams.to);
        }

        this.selectedQuickFilterId = quickActiveFilter?.id;
        this.branchIds = commonsService.parseArrayStateParam($stateParams.branchIds) || quickActiveFilter?.settings.branchIds || [];
        this.agentIds = commonsService.parseArrayStateParam($stateParams.agentIds) || quickActiveFilter?.settings.agentIds || [];
        this.accountIds = commonsService.parseArrayStateParam($stateParams.accountIds) || quickActiveFilter?.settings.accountIds || [];
        this.tags = commonsService.parseArrayStateParam($stateParams.tags) || quickActiveFilter?.settings.tags || [];
        this.agentType = $stateParams.agentType || quickActiveFilter?.settings.agentType;


        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Drivers"});
        triBreadcrumbsService.addCrumb({name: "Routes Accuracy"});
        triBreadcrumbsService.addCrumb({name: "Performance"});
        triBreadcrumbsService.addCrumb({name: "Reports"});
        triBreadcrumbsService.addCrumb({name: "Reporting & Analytics"});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      }
    })


    // Effectiveness
    .state('reports.effectiveness', {
      url: '/effectiveness',
      abstract: true,
      template: '<ui-view></ui-view>'
    })

    // Effectiveness - Time Based Activity - Shippers
    .state('reports.effectiveness.time-based-activity-shippers', {
      url: '/time-based-activity/shippers',
      reloadOnSearch: false,
      template: '<reports-activity-shippers from="from" to="to"></reports-activity-shippers>',
      controller: function ($scope, $stateParams, triBreadcrumbsService) {

        if ($stateParams.from || $stateParams.to) {
          $scope.from = parseInt($stateParams.from);
          $scope.to = parseInt($stateParams.to);
        }

        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Shipper Accounts"});
        triBreadcrumbsService.addCrumb({name: "Time Based Activity"});
        triBreadcrumbsService.addCrumb({name: "Effectiveness"});
        triBreadcrumbsService.addCrumb({name: "Reports"});
        triBreadcrumbsService.addCrumb({name: "Reporting & Analytics"});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      }
    })

    // Effectiveness - Time Based Activity - Vendors
    .state('reports.effectiveness.time-based-activity-vendors', {
      url: '/time-based-activity/vendors',
      reloadOnSearch: false,
      template: '<reports-activity-vendors from="from" to="to"></reports-activity-vendors>',
      controller: function ($scope, $stateParams, triBreadcrumbsService) {

        if ($stateParams.from || $stateParams.to) {
          $scope.from = parseInt($stateParams.from);
          $scope.to = parseInt($stateParams.to);
        }

        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Carrier Accounts"});
        triBreadcrumbsService.addCrumb({name: "Time Based Activity"});
        triBreadcrumbsService.addCrumb({name: "Effectiveness"});
        triBreadcrumbsService.addCrumb({name: "Reports"});
        triBreadcrumbsService.addCrumb({name: "Reporting & Analytics"});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      }
    })

    // Effectiveness - Time Based Activity - Drivers
    .state('reports.effectiveness.time-based-activity-drivers', {
      url: '/time-based-activity/drivers',
      reloadOnSearch: false,
      template: '<reports-activity-drivers from="from" to="to"></reports-activity-drivers>',
      controller: function ($scope, $stateParams, triBreadcrumbsService) {

        $scope.type = 'drivers';

        if ($stateParams.from || $stateParams.to) {
          $scope.from = parseInt($stateParams.from);
          $scope.to = parseInt($stateParams.to);
        }

        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Drivers"});
        triBreadcrumbsService.addCrumb({name: "Time Based Activity"});
        triBreadcrumbsService.addCrumb({name: "Effectiveness"});
        triBreadcrumbsService.addCrumb({name: "Reports"});
        triBreadcrumbsService.addCrumb({name: "Reporting & Analytics"});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      }
    })


    // Effectiveness - Timeline Activity - Shippers
    .state('reports.effectiveness.service-time-activity-shippers', {
      url: '/service-time-activity/shippers',
      reloadOnSearch: false,
      template: '<reports-service-time-shippers from="from" to="to"></reports-service-time-shippers>',
      controller: function ($scope, $stateParams, triBreadcrumbsService) {

        if ($stateParams.from || $stateParams.to) {
          $scope.from = parseInt($stateParams.from);
          $scope.to = parseInt($stateParams.to);
        }

        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Shipper Accounts"});
        triBreadcrumbsService.addCrumb({name: "Timeline Activity"});
        triBreadcrumbsService.addCrumb({name: "Effectiveness"});
        triBreadcrumbsService.addCrumb({name: "Reports"});
        triBreadcrumbsService.addCrumb({name: "Reporting & Analytics"});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      }
    })

    // Effectiveness - Timeline Activity - Vendors
    .state('reports.effectiveness.service-time-activity-vendors', {
      url: '/service-time-activity/vendors',
      reloadOnSearch: false,
      template: '<reports-service-time-vendors from="from" to="to"></reports-service-time-vendors>',
      controller: function ($scope, $stateParams, triBreadcrumbsService) {

        if ($stateParams.from || $stateParams.to) {
          $scope.from = parseInt($stateParams.from);
          $scope.to = parseInt($stateParams.to);
        }

        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Carrier Accounts"});
        triBreadcrumbsService.addCrumb({name: "Timeline Activity"});
        triBreadcrumbsService.addCrumb({name: "Effectiveness"});
        triBreadcrumbsService.addCrumb({name: "Reports"});
        triBreadcrumbsService.addCrumb({name: "Reporting & Analytics"});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      }
    })

    // Effectiveness - Timeline Activity - Drivers
    .state('reports.effectiveness.service-time-activity-drivers', {
      url: '/service-time-activity/drivers',
      reloadOnSearch: false,
      template: '<reports-service-time-drivers from="from" to="to"></reports-service-time-drivers>',
      controller: function ($scope, $stateParams, triBreadcrumbsService) {

        if ($stateParams.from || $stateParams.to) {
          $scope.from = parseInt($stateParams.from);
          $scope.to = parseInt($stateParams.to);
        }

        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Drivers"});
        triBreadcrumbsService.addCrumb({name: "Timeline Activity"});
        triBreadcrumbsService.addCrumb({name: "Effectiveness"});
        triBreadcrumbsService.addCrumb({name: "Reports"});
        triBreadcrumbsService.addCrumb({name: "Reporting & Analytics"});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      }
    })


}
